module.exports = __webpack_public_path__ + "img/type1-bg2.6fbeba8d.png";